export default __webpack_public_path__ + "static/media/sec2.fa1458c0.png";